export default __webpack_public_path__ + "static/media/Purchase.cf82aa92.mp4";